import type { ConceptChipDomain } from './domain'
import type { ConceptChipDLevel } from './types'

export const CONCEPT_CHIP_D_LEVEL_TEXT_DICT: Record<ConceptChipDLevel, string> = {
  A: '개념',
  B: '기본',
  C: '심화',
}

export const ACHIEVEMENT_COLOR_DICT: Record<ConceptChipDomain.LevelOfAchievement, string> = {
  WHITE: '#fff',
  GRAY: '#E0E0E0',
  SAD: '#FF705C',
  RED: '#FF705C',
  YELLOW: '#FFC34D',
  GREEN: '#7FE166',
  SMILE: '#7FE166',
}
export const ACHIEVEMENT_LEVEL_KO_TEXT_DICT: Record<ConceptChipDomain.LevelOfAchievement, string> =
  {
    WHITE: '화이트',
    GRAY: '그레이',
    SAD: '새드',
    RED: '레드',
    YELLOW: '옐로우',
    GREEN: '그린',
    SMILE: '스마일',
  }

export const LEVEL_OF_ACHIEVEMENT_COUNT_DICT: Record<ConceptChipDomain.LevelOfAchievement, number> =
  {
    WHITE: 0,
    GRAY: 0,
    SAD: 0,
    RED: 0,
    YELLOW: 0,
    GREEN: 0,
    SMILE: 0,
  }
